"use client";

import React from "react";

function SupplierPage() {
  return <h4>Supplier Page</h4>;
}

export default SupplierPage;
